import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EmailVerification from "./pages/EmailVerification";
import { register } from "swiper/element/bundle";
import ForgotPassword from "./pages/ForgotPassword";
import LandingPage from "./pages/LandingPage";
import PasswordVerification from "./pages/PasswordVerification";
import AboutPage from "./pages/AboutPage"
import TranscoPage from "./pages/TranscoPage"
import FAQpage from "./pages/FAQpage"
import LogIn from "./pages/LogIn";
import EmailVerificationOTP from "./pages/EmailVerificationOTP";
import Otp from './components/Otp';
import AccountOverview from "./pages/AccountOverview";
import SearchPage from "./pages/SearchPage";
import TicketOption from "./pages/TicketOptionPage";
import ForgotPassword1 from "./pages/Forgot-Password";
import ContactUs from "./pages/ContactUs";
import Register from  "./pages/Signup";

function App() {
  register();

  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/otp-page" element={< EmailVerificationOTP />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/password-verification" element={<PasswordVerification />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot-password1" element={<ForgotPassword1 />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/transco" element={<TranscoPage />} />
          <Route path="/faq" element={<FAQpage />} />
          <Route path="/account-overview" element={<AccountOverview />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/ticket-option" element={<TicketOption />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
